import angular from 'angular';
import MessagesTabComponent from './messages-tab-component';

export default angular.module('messages-tab', []).component('messagesTab', new MessagesTabComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/messages-tab/messages-tab-module.js